import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DifferenceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"difference"}/>
}
